import * as React from "react";
const Star = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#DAA520"
      d="M9.403.563a1.001 1.001 0 0 0-1.8 0l-2.01 4.134-4.487.662a.998.998 0 0 0-.557 1.7l3.257 3.222-.77 4.553a1.003 1.003 0 0 0 1.46 1.05l4.01-2.14 4.009 2.14a1 1 0 0 0 1.46-1.05l-.772-4.553 3.256-3.222a.999.999 0 0 0-.556-1.7l-4.491-.662L9.402.562Z"
    />
  </svg>
);
export default Star;
